import React, { useMemo, useState } from "react";

const EligiblityHistoryStatusTabs = ({ columns, data, type }) => {
  console.log(data, 'datasssss', type);
  console.log(data?.filter(it => it.CovergeType === 'Others'));





  const typeOthersSet = new Set(["Active Coverage", "Co-Insurance", "Co-Payment", "Deductible", "Out of Pocket (Stop Loss)", "Limitations", "Inactive", "Non-Covered", "Benefit Description", 'Active - Pending Investigation', 'Primary Care Provider', 'Other or Additional Payor',]);
  const checkCondition = (item) => type !== "Others" ? item.CovergeType === type : !typeOthersSet.has(item.CovergeType);
  const [expandedRow, setExpandedRow] = useState({}); // Track expanded state for each row

  let QuantityQualDataExist = data?.filter(it => it.CovergeType === type).some(item => item.QuantityQual !== "");
  let QuantityValueDataExist = data?.filter(it => it.CovergeType === type).some(item => item.QuantityValue !== "");

  const filteredData = useMemo(() => {
    if (type === "Active Coverage" || type === "Inactive" || type === "Non-Covered") {
      return data?.filter(it => it.CovergeType === type) || [];
    }
    return [];
  }, [data, type]);

  const timePeriodExists = useMemo(() => filteredData.some(item => item.TimePeriod), [filteredData]);
  const amountPerExists = useMemo(() => filteredData.some(item => item["Amount/Perc."]), [filteredData]);
  const planNetworkExists = useMemo(() => filteredData.some(item => item.PlanNetwork), [filteredData]);
  const authReqExists = useMemo(() => filteredData.some(item => item.AuthReq), [filteredData]);
  // const serves = useMemo(() => filteredData.some(item => item.Services), [filteredData]);




  // console.log(serves,'serves');


  const handleExpanded = (id) => {
    setExpandedRow(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const checkHideColumnsCondition = (item) => {
    // If data is undefined, return true (show column)
    if (QuantityQualDataExist === undefined || QuantityValueDataExist === undefined) {
      return true;
    }

    // Show "Quantity" column if QuantityQualDataExist is true
    if (!QuantityQualDataExist && item === "Quantity") return false;

    // Show "Quan. Value" column if QuantityValueDataExist is true
    if (!QuantityValueDataExist && item === "Quan. Value") return false;

    // Hide "Insurance Type" and "Plan Description" for specific insurance types
    if (
      ["Co-Insurance", "Co-Payment", "Deductible", "Out of Pocket (Stop Loss)", "Limitations", "Others"].includes(type) &&
      // ["Insurance Type", "Plan Description"].includes(item)
      ["Plan Description"].includes(item)

    ) {
      return false; // Hide the column
    }
    if (type === "Active Coverage" || type === "Inactive" || type === "Non-Covered") {
      if (!timePeriodExists && item === "Time Period") return false;
      if (!amountPerExists && item === "Amount/Perc.") return false;
      if (!planNetworkExists && item === "Plan Network") return false;
      if (!authReqExists && item === "Auth/Cert") return false;
      // if (!serves && item === "Services") return false;


    }

    return true; // Show all other columns by default
  };

  return (<>
    <div className="appointment-grid ar-task-table h-100 hk-expand-table">
      <div className="copay-table overflow-visible">
        <table>
          <thead>
            <tr>
              {columns &&
                columns.filter(checkHideColumnsCondition).map((item) => {
                  return (
                    <th>
                      <div className="table-head">
                        {item}
                        <i className="icon-arrows-gray"></i>
                      </div>
                    </th>
                  );
                })}
            </tr>
          </thead>
          <tbody>
            {data?.filter(checkCondition).map((item) => {
              // console.log("item", item);
              return (
                <>
                  {item?.isMessage ? (
                    <tr className="table-msgRow">
                      <td>
                        <div className="table-data">
                          Message(s):&nbsp;
                        </div>
                      </td>
                      <td colSpan="8">
                        <div className="table-data">
                          {item?.message}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td>
                        <div className="table-data">
                          {item.CovergeLevel}
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-between gap-1 align-items-end table-data">
                          <div className="text-wrap lh-normal">
                            {item.Services.split(' - ').slice(0, expandedRow[`${item.EligibilityINFOID}-${type}`] ? item.Services.length : 5).map((service, index) => (
                              <React.Fragment key={index}>
                                {service} <br />
                              </React.Fragment>
                            ))}
                          </div>
                          {item.Services.split(' - ').length > 5 && (
                            <p
                              className="text fs-11 validate-color text-decoration-underline text-end cursor-pointer text-nowrap lh-normal"
                              onClick={() => handleExpanded(`${item.EligibilityINFOID}-${type}`)}
                            >
                              {!expandedRow[`${item.EligibilityINFOID}-${type}`] ? 'Show More' : 'Show Less'}
                            </p>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className="table-data">
                          {item.InsuranceType}
                        </div>
                      </td>
                      {!["Co-Insurance", "Co-Payment", "Deductible", "Out of Pocket (Stop Loss)", "Limitations", "Others"].includes(type) ?
                        <>

                          <td>
                            <div className="table-data">
                              {item.PlanDescription}
                            </div>
                          </td>
                        </> : null}
                      {!["Active Coverage", "Inactive", "Non-Covered"].includes(type) ? <>
                        <td>
                          <div className="table-data">
                            {item.TimePeriod}
                          </div>
                        </td>
                        <td>
                          <div className="table-data">
                            {item[`Amount/Per`]}
                          </div>
                        </td>
                      </> : null}

                      {QuantityQualDataExist ?
                        <td>
                          <div className="table-data">
                            {item.QuantityQual}
                          </div>
                        </td> : null}
                      {QuantityValueDataExist ?
                        <td>
                          <div className="table-data">
                            {item.QuantityValue}
                          </div>
                        </td> : null}
                      {!["Active Coverage", "Inactive", "Non-Covered"].includes(type) ? <>
                        <td>
                          <div className="table-data">
                            {item.PlanNetwork}
                          </div>
                        </td>
                        <td>
                          <div className="table-data">{item.AuthReq}</div>
                        </td>
                      </> : null}
                    </tr>
                  )}
                  {(
                    item?.MessageText1 || item?.CPTModifier ||
                    (item?.Additional && item?.Additional.length > 0 && item.Additional.some(addItem => addItem.Entity || addItem.AdditionalDate))) &&
                    <tr>
                      <td colSpan={12} className='message text lh-16'>
                        {(item?.MessageText1 || item?.MessageText2 || item?.MessageText3 || item?.MessageText4 || item?.MessageText5 || item?.MessageText6 || item?.MessageText7 || item?.MessageText8 || item?.MessageText9 || item?.MessageText10) && (
                          <>
                            Message(s):&nbsp;
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num, index) => {
                              const msg = item[`MessageText${num}`];
                              return msg ? `${index > 0 && item[`MessageText${index}`] ? ', ' : ''}${msg}` : '';
                            })}
                            <br />
                          </>
                        )}
                        {item?.CPTModifier && item?.CPTModifier !== item?.Services && (
                          <div className="mt-1">
                            Procedure Code(s): {item.CPTModifier}
                          </div>
                        )}
                        {/* Message(s):&nbsp;
                        {item?.MessageText1}
                        {item?.MessageText2 ? `, ${item?.MessageText2}` : ''}{item?.MessageText3 ? `, ${item?.MessageText3}` : ''}
                        {item?.MessageText4 ? `, ${item?.MessageText4}` : ''}{item?.MessageText5 ? `, ${item?.MessageText5}` : ''}
                        {item?.MessageText6 ? `, ${item?.MessageText6}` : ''}{item?.MessageText7 ? `, ${item?.MessageText7}` : ''}
                        {item?.MessageText8 ? `, ${item?.MessageText8}` : ''}{item?.MessageText9 ? `, ${item?.MessageText9}` : ''}
                        {item?.MessageText10 ? `, ${item?.MessageText10}` : ''}<br /> */}
                        {item?.Additional && item?.Additional.map((addItem, idx) => (
                          <div key={idx}>
                            {addItem.Entity && <div>{addItem.Entity}</div>}
                            {addItem.AdditionalDate && <div>{addItem.AdditionalDate}</div>}
                          </div>
                        ))}
                        {/* {item?.Additional && item?.Additional.length > 0 && (
                          <div>
                            <div><strong>Entity :</strong></div>
                            {item?.Additional?.map((addItem, idx) =>
                              addItem.Entity ? <div key={`entity-${idx}`}>{addItem.Entity}</div> : null
                            )}

                            <div style={{ marginTop: '10px' }}><strong>Additional :</strong></div>
                            {item.Additional.map((addItem, idx) =>
                              addItem.AdditionalDate ? <div key={`additional-${idx}`}>{addItem.AdditionalDate}</div> : null
                            )}
                          </div>
                        )} */}



                      </td>
                    </tr>}
                </>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  </>);
}

export default EligiblityHistoryStatusTabs;